import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { AuthenticationService } from 'app/auth/service';
import { ToastService } from 'app/components/toasts/toasts.service';
import { DataService } from 'app/services/data.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BillingComponent implements OnInit, OnDestroy {
  public coreConfig: any;
  private _unsubscribeAll: Subject<any>;
  public alertMessage = null;
  public invoices = [];
  public loading: boolean = true;
  public cardForm: FormGroup = new FormGroup({
    number: new FormControl(null, Validators.required),
    expMonth: new FormControl(null, Validators.required),
    expYear: new FormControl(null, Validators.required),
    cvc: new FormControl(null, Validators.required),
  });

  public reasonOfCanceling: FormControl = new FormControl(null, [Validators.required]);

  constructor(
    private _coreConfigService: CoreConfigService,
    private _toastrService: ToastService,
    private _dataService: DataService,
    private _router: Router,
    private _authService: AuthenticationService) { 
      this._unsubscribeAll = new Subject();
      // Configure the layout
      this._coreConfigService.config = {
        layout: {
          menu: {
            hidden: true,
            collapsed: false
          },
          customizer: true,
          enableLocalStorage: false
        }
      };
    }

  // convenience getter for easy access to form fields
  get cf() {
    return this.cardForm.controls;
  }

  ngOnInit(): void {
    /* get user invoice */
    this.getInvoice();

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  updateCard(){
    /* success message */
    // Card updated successfully next subscription would be charged from this card
    this._dataService.createUpdateCard(this.cardForm.value).toPromise().then((result: any) =>{
      if(result.code == 1001){

        this.alertMessage = `${result.message}`;

        // this._toastrService.show(`${result.message}`, {
        //   delay: 2000,
        //   classname: 'bg-primary text-light',
        //   autohide: true
        // });
      }
    }).catch((err) =>{
    /* error message */
    // Error occured while updating card check card details
      this._toastrService.show(`${err}`, {
        delay: 2000,
        classname: 'bg-danger text-light',
        autohide: true
      });
    });

  }

  cancelSubscription(){
    // Subscription Canceled but you can use our free services anytime
    this._dataService.cancelSubscription(this.reasonOfCanceling.value).toPromise().then((result: any) =>{
      if(result.code == 1001){
        this._dataService.refreshUserToken().toPromise().then((result:any) =>{
          this._authService.setUser(result.data);
          let userInfo: any = result.data
          this.alertMessage = `Your Subscription will be expire on ${new Date(userInfo.user.stripeData.subsciption.expiryDate).toDateString()}`;
          setTimeout(() =>{
            if(userInfo.user.defaultProduct == 'STOCK'){
              this._router.navigate(['/stock']);
            } else {
              this._router.navigate(['/crypto']);
            }
          }, 3000);
        }).catch((err) =>{
          this._toastrService.show(`${err}`, {
            delay: 2000,
            classname: 'bg-danger text-light',
            autohide: true
          });
        });
      }
    }).catch((err) =>{
      this._toastrService.show(`${err}`, {
        delay: 2000,
        classname: 'bg-danger text-light',
        autohide: true
      });
    });
  }

  getInvoice(){
    this.loading = true;
    this._dataService.getUserInvoices().subscribe((result: any) =>{
      this.invoices = result.data;
      this.loading = false;
    });
  }

  downloadPdf(url:any){
    window.open(url,"_blank")
  }

}
